import React, { useContext, useEffect, useState } from "react";
import TableLayout from '../../table-layout/hoa-table-layout';
import SuccessMessage from "../../success-message/hoa-success-message";
import FilteringComponenet from "../../filtering-component/hoa-filtering-comp";

import config from "../../../hoa-config";
import { GlobalContext } from '../../../context/hoa-global-context';
import dashboardServices from "../../../services/hoa-dashboard-api-service";
import { camelCaseToSeparatedWords } from "../../../utility/helper";
import ConfiguratorContents from "../configurator-contents/configurator-contents";
import { fieldConfigurator } from "../configurator-contents/data";
import hoaDatastore from "../../../store/hoa-datastore";
import hoaConfig from '../../../hoa-config'

export default function ConfiguratorModuleSelector(props: any) {
    const { orgId, orgName } = props
    const { updateView, view: views, updateSelectedValues } = useContext<any>(GlobalContext);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [view, setView] = useState(views === "back-to-list" ? 'list' : 'view');


    const headers = config.dashboard['DataFieldConfigurator']?.tableLayout?.title;
    const columns = config.dashboard['DataFieldConfigurator']?.tableLayout?.columns;
    const filteringTitle = config.dashboard['DataFieldConfigurator']?.filterComponent?.title;
    const filteringSubTitle = config.dashboard['DataFieldConfigurator']?.filterComponent?.subTitle;

    useEffect(() => {
        if (views === 'back-to-list') {
            setView('list');
            updateView('list');
            return;
        } else if (views === 'view-more-details') {
            setView('view');
            updateView('view');
            return;
        }
        updateView(view);
    }, [views === 'back-to-list', views === 'view-more-details', view])

    const getRequests = async (numberOfRequests: number, pageNo: number) => {
        const { data } = await dashboardServices.getDataFieldConfiguratorByOrganizationId(orgId);
        if (Object.keys(data).length > 0) {
            const { moduleName, description, updatedAt } = data.hoaConfig
            return {
                data: [{ content: data, organizationName: data.organizationName, objectId: data.objectId, moduleName, description, lastUpdated: updatedAt, publishedDate: updatedAt }],
                count: 1
            }
        }
        const hoaDescription = `${hoaConfig.HOA_CONFIG_DESCRIPTION} - ${orgName}.`
        return ({
            data: [{ content: { organizationId: orgId, organizationName: orgName, hoaConfig: { moduleName: "HOA", description: hoaDescription, fieldData: fieldConfigurator, publishedBy: hoaDatastore.ownerInformation.name } }, moduleName: "HOA", organizationName: orgName, description: hoaDescription, lastUpdated: "Not updated", publishedDate: "Not published" }],
            count: 1
        });
    };


    return (
        <div style={{ marginBottom: '20px' }}>
            {
                view === 'list' ?
                    <>
                        <FilteringComponenet
                            onAddClick={setView}
                            title={camelCaseToSeparatedWords(filteringTitle)}
                            subTitle={filteringSubTitle}
                            tagType={"DataFieldConfigurator"}
                            orgName={orgName}
                        />
                        <TableLayout
                            fetchResult={getRequests}
                            headers={headers}
                            columns={columns}
                            tagType={"DataFieldConfigurator"}
                            updateView={setView}
                            selectedDataConfigOrg={orgName}
                            updateSelectedValues={updateSelectedValues}
                        />
                        <SuccessMessage
                            success={success}
                            setSuccess={setSuccess}
                            message={message}
                        />
                    </>
                    : <ConfiguratorContents
                        updateView={setView}
                        view={view}
                        orgId={orgId}
                        orgName={orgName}
                        setMessage={setMessage}
                        setSuccess={setSuccess}
                    />
            }
        </div>

    )
}